import { HalfContainer } from "common/common.styled";
import Button from "components/Button";
import { Grid } from "components/Grid/Grid";
import RadioGroup from "components/RadioGroup";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import TextInput from "components/TextInput";
import { FC } from "react";
import { IconContext } from "react-icons";
import { BiLoaderAlt } from "react-icons/bi";
import { BsArrowLeft } from "react-icons/bs";
import theme from "theme";

import {
    JobPurposeWrapper,
    LoaderContainer,
} from "../JobPurpose/JobPurpose.styled";
import { RadioInputWrapper } from "./JobBudget.styled";
import { useJobBudget } from "./useJobBudget";

export const JobBudget: FC = () => {
    const {
        agencyName,
        location,
        purposeName,
        budgetDetails,
        budgetDetailsErrors,
        handleDropdownChange,
        handleTextInputChange,
        currenciesData,
        handleBack,
        handleSubmit,
        isFetching,
        isSubmitting,
    } = useJobBudget();

    return (
        <JobPurposeWrapper>
            <HalfContainer>
                {isFetching && (
                    <IconContext.Provider value={{ className: "loader" }}>
                        <LoaderContainer>
                            <BiLoaderAlt />
                        </LoaderContainer>
                    </IconContext.Provider>
                )}
                <Text variant="body3" color={theme.colors.grey.primary}>
                    I am posting a job on behalf of{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {agencyName}
                    </Text>{" "}
                    for a{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {purposeName}{" "}
                    </Text>
                    in{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {location}
                    </Text>
                </Text>
                {!isFetching && (
                    <>
                        <RadioInputWrapper>
                            <Text
                                variant="button1"
                                color={theme.colors.grey.dark}
                            >
                                Set a project budget
                            </Text>
                            <RadioGroup
                                style={{ gap: "0rem" }}
                                label=""
                                disabled={isSubmitting}
                                options={[
                                    {
                                        label: "Professional Pay",
                                        value: "professional_pay",
                                    },
                                    {
                                        label: "Deferred Pay",
                                        value: "deferred_pay",
                                    },
                                    {
                                        label: "Barter",
                                        value: "barter",
                                    },
                                    {
                                        label: "Unpaid",
                                        value: "unpaid",
                                    },
                                ]}
                                value={budgetDetails.payType}
                                columns={4}
                                name="payType"
                                onChange={handleTextInputChange}
                            />
                        </RadioInputWrapper>
                        <Grid row={true} marginTop={1}>
                            <SingleSelect
                                options={[
                                    { label: "Hourly", value: "hourly" },
                                    { label: "Daily", value: "daily" },
                                    { label: "Weekly", value: "weekly" },
                                    { label: "Bi-Weekly", value: "bi-weekly" },
                                    { label: "Monthly", value: "monthly" },
                                ]}
                                label="Duration Cycle"
                                required
                                // minWidth="11rem"
                                placeholder="Select Duration Cycle"
                                disabled={isSubmitting}
                                value={budgetDetails.durationCycle}
                                onChange={(value) =>
                                    handleDropdownChange("durationCycle", value)
                                }
                                errorText={budgetDetailsErrors.durationCycle}
                            />
                        </Grid>
                        <Grid row={true} marginTop={1} columnGap={1}>
                            <SingleSelect
                                options={currenciesData}
                                label="Select Currency"
                                required
                                searchable
                                // minWidth="11rem"
                                placeholder="Select Currency"
                                value={budgetDetails.currency}
                                disabled
                                onChange={(value) =>
                                    handleDropdownChange("currency", value)
                                }
                                errorText={budgetDetailsErrors.currency}
                            />
                            <TextInput
                                label="Amount (min)"
                                required
                                // minWidth="11rem"
                                placeholder="11000"
                                name="minAmount"
                                value={budgetDetails.minAmount}
                                onChange={handleTextInputChange}
                                disabled={isSubmitting}
                                errorMsg={budgetDetailsErrors.minAmount}
                            />
                            <TextInput
                                label="Amount (max)"
                                required
                                // minWidth="11rem"
                                placeholder="50000"
                                name="maxAmount"
                                value={budgetDetails.maxAmount}
                                onChange={handleTextInputChange}
                                disabled={isSubmitting}
                                errorMsg={budgetDetailsErrors.maxAmount}
                            />
                        </Grid>
                        <Grid row={true} marginTop={1}>
                            <TextInput
                                multiLine
                                label="Additional Compensation (optional)"
                                placeholder="Eg. Benefits"
                                minWidth="30rem"
                                name="additionalCompensation"
                                value={budgetDetails.additionalCompensation}
                                onChange={handleTextInputChange}
                                disabled={isSubmitting}
                                errorMsg={
                                    budgetDetailsErrors.additionalCompensation
                                }
                            />
                        </Grid>
                        <br />
                        <Grid row={true} columnGap={1} expanded>
                            <SingleSelect
                                options={[
                                    { label: "Select Status", value: "" },
                                    { label: "Active", value: "active" },
                                    { label: "Inactive", value: "inactive" },
                                    { label: "Expired", value: "expired" },
                                    { label: "Draft", value: "draft" },
                                ]}
                                label="Status"
                                required
                                searchable
                                // minWidth="11.5rem"
                                placeholder="Select Status"
                                value={budgetDetails.status || ""}
                                onChange={(value) =>
                                    handleDropdownChange("status", value)
                                }
                                errorText={budgetDetailsErrors.status}
                            />
                        </Grid>
                    </>
                )}
                <Grid marginTop={3} marginBottom={2} columnGap={1}>
                    <Button
                        type="button"
                        variant="outlined"
                        icon={<BsArrowLeft />}
                        iconPosition="prefix"
                        onClick={handleBack}
                    >
                        Back
                    </Button>
                    <Button
                        type="button"
                        variant="filled"
                        isLoading={isSubmitting}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </Grid>
            </HalfContainer>
        </JobPurposeWrapper>
    );
};
